import { loadableWithFallback } from '@vision/ui/utils';
import type { ReportsDetailGraphicSchemaValues } from '@vision/ui/interfaces';

export const BenchmarkComparisonTable = loadableWithFallback<{
  values: ReportsDetailGraphicSchemaValues;
  data: unknown;
}>(() => import('./BenchmarkComparisonTable'));
